// TODO: Need to be deleted, for data mock.
export const sleep = (delay: number) => new Promise(resolve => setTimeout(resolve, delay));
